import React, { useState } from 'react';
import { calculateSIP, calculateEMI, formatINR } from './finance';

const Field = ({ label, value, onChange, ...rest }) => (
  <div style={{ marginBottom: '1rem' }}>
    <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500 }}>{label}</label>
    <input
      type="number"
      className="calculator-input"
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      {...rest}
    />
  </div>
);

export const SipCalculator = () => {
  const [amount, setAmount] = useState(5000);
  const [tenureYears, setTenure] = useState(10);
  const [annualRate, setRate] = useState(12);
  const result = calculateSIP({ amount, tenureYears, annualRate });

  return (
    <div className="calculator-widget" data-testid="sip-calculator">
      <h3 style={{ fontSize: '1.5rem', fontWeight: 600, color: 'var(--primary-navy)', marginBottom: '1.5rem', textAlign: 'center' }}>
        SIP Calculator
      </h3>
      <Field label="Monthly Investment (₹)" value={amount} onChange={setAmount} min="500" step="500" />
      <Field label="Investment Period (Years)" value={tenureYears} onChange={setTenure} min="1" max="40" />
      <Field label="Expected Annual Return (%)" value={annualRate} onChange={setRate} min="1" max="30" step="0.1" />
      <div className="calculator-result">
        <div className="result-amount">{formatINR(result.maturityAmount)}</div>
        <div style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: '1rem' }}>Maturity Amount</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', fontSize: '0.875rem' }}>
          <div>
            <div style={{ fontWeight: 600, color: 'var(--primary-navy)' }}>Invested</div>
            <div>{formatINR(result.investedAmount)}</div>
          </div>
          <div>
            <div style={{ fontWeight: 600, color: 'var(--success-green)' }}>Returns</div>
            <div>{formatINR(result.returns)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const EmiCalculator = () => {
  const [principal, setPrincipal] = useState(1000000);
  const [annualRate, setRate] = useState(8.5);
  const [tenureYears, setTenure] = useState(20);
  const result = calculateEMI({ principal, annualRate, tenureYears });

  return (
    <div className="calculator-widget" data-testid="emi-calculator">
      <h3 style={{ fontSize: '1.5rem', fontWeight: 600, color: 'var(--primary-navy)', marginBottom: '1.5rem', textAlign: 'center' }}>
        EMI Calculator
      </h3>
      <Field label="Loan Amount (₹)" value={principal} onChange={setPrincipal} min="100000" step="50000" />
      <Field label="Loan Tenure (Years)" value={tenureYears} onChange={setTenure} min="1" max="30" />
      <Field label="Interest Rate (% per annum)" value={annualRate} onChange={setRate} min="1" max="20" step="0.1" />
      <div className="calculator-result">
        <div className="result-amount">{formatINR(result.emi)}</div>
        <div style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: '1rem' }}>Monthly EMI</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', fontSize: '0.875rem' }}>
          <div>
            <div style={{ fontWeight: 600, color: 'var(--primary-navy)' }}>Total Amount</div>
            <div>{formatINR(result.totalAmount)}</div>
          </div>
          <div>
            <div style={{ fontWeight: 600, color: 'var(--accent-gold-dark)' }}>Total Interest</div>
            <div>{formatINR(result.totalInterest)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const Calculators = () => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
      gap: '3rem'
    }}
    data-testid="calculators-grid"
  >
    <SipCalculator />
    <EmiCalculator />
  </div>
);
